import { login as loginApi, logout, getInfo, getHomeAccess } from "@/api/_user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { resetRouter } from "@/router";
import Cookies from "js-cookie";
import sysMenuApi from "@/api/system/sysMenu";
const getDefaultState = () => {
  return {
    token: getToken(),
    name: "",
    avatar: "",
    routes: [],
    homeAccess: false,
    permissions: [] // 添加权限字段
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_USERID: (state, id) => {
    state.userId = id;
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  },
  SET_HOME_ACCESS: (state, allowed) => {
    state.homeAccess = allowed === true;
  },
  SET_ROUTE: (state, routes) => {
    state.routes = routes;
  }
};

const actions = {
  async getHomeAccess({ commit }) {
    commit("SET_HOME_ACCESS", false);
    const response = await getHomeAccess();
    if (!response || String(response.code) !== "0" || typeof response.data !== "boolean") {
      throw new Error("首页权限加载失败，请重试");
    }
    commit("SET_HOME_ACCESS", response.data);
    return response.data;
  },
  // user login
  login({ commit }, userInfo) {
    
    // 先清除旧的token，确保使用新的token
    removeToken();
    commit("RESET_STATE");
    localStorage.removeItem("menuList");
    localStorage.removeItem("routes");
    commit("SET_TOKEN", "");
    
    const { username, password, captcha, uuid } = userInfo;
    return new Promise((resolve, reject) => {
      loginApi({
        captcha,
        username: username.trim(),
        password: btoa(password),
        uuid
      })
        .then(response => {
          console.log("Login API response:", response);
          console.log("Response code:", response.code);
          console.log("Response message:", response.message);
          console.log("Response data:", response.data);
          
          // 检查登录是否成功
          if (response.code === '0' || response.code === 0) {
            const { data } = response;
            console.log("Saving token:", data);
            commit("SET_TOKEN", data);
            setToken(data);
            console.log("Token saved, current token:", getToken());
            resolve();
          } else {
            console.error("Login failed with code:", response.code);
            reject(new Error(response.message || '登录失败'));
          }
        })
        .catch(error => {
          console.error("Login API error details:", error);
          console.error("Error response:", error.response);
          console.error("Error request:", error.request);
          console.error("Error message:", error.message);
          
          // 提供更具体的错误信息
          let errorMessage = '登录失败';
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.message) {
            errorMessage = error.message;
          }
          
          reject(new Error(errorMessage));
        });
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      console.log("Getting user info with token:", state.token);
      getInfo(state.token)
        .then(response => {
          console.log("User info API response:", response);
          
          // 检查API返回的code
          if (response.code === '-1' || response.code === -1) {
            reject("Verification failed, please Login again.");
            return;
          }
          
          const { data } = response;
          if (!data) {
            reject("Verification failed, please Login again.");
            return;
          }

          const { userName, headImg, id } = data;
          commit("SET_NAME", userName);
          commit("SET_AVATAR", headImg);
          commit("SET_USERID", id);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          removeToken(); // must remove  token  first
          resetRouter();
          Cookies.remove("adminInfo");
          localStorage.removeItem("menuList");
          localStorage.removeItem("routes");
          commit("RESET_STATE");
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPermissions({ commit, state }) {
    return new Promise((resolve, reject) => {
     // console.log('开始获取用户权限...');
     // console.log('当前token:', state.token);
      
      // 检查是否有token
      if (!state.token) {
       // console.error('没有token，无法获取权限');
        commit("SET_PERMISSIONS", []);
        resolve({ data: [] });
        return;
      }
      
     // console.log('准备调用权限API...');
      
      // 使用原生fetch确保在Network中显示
      const permissionUrl = `${process.env.VUE_APP_BASE_API}/sys/sysMenu?resType=3&code=&pageNo=1&pageSize=999`;
     // console.log('权限API URL:', permissionUrl);
      
      window.fetch(permissionUrl, {
        method: 'GET',
        headers: {
          'Token': `DU ${state.token}`
        }
      }).then(response => response.json())
        .then(res => {
          //console.log('权限API响应:', res);
          
          // 检查响应是否有效
          if (!res) {
           // console.warn('权限API返回空响应');
            commit("SET_PERMISSIONS", []);
            resolve({ data: [] });
            return;
          }
          
          // 尝试多种可能的数据结构
          let list = [];
          if (res.data && res.data.list) {
            list = res.data.list;
          } else if (res.list) {
            list = res.list;
          } else if (res.data) {
            list = res.data;
          }
          
         // console.log('最终权限列表:', list);
         // console.log('权限列表长度:', list.length);
          
          // 确保list是数组
          if (!Array.isArray(list)) {
          //  console.warn('权限数据不是数组格式:', list);
            list = [];
          }
          
          const permissions = list.map(it => it.permissionIdentification).filter(p => p);
         // console.log('提取的权限标识:', permissions);
          commit("SET_PERMISSIONS", permissions);
         // console.log('权限已保存到store');
          resolve(res);
        })
        .catch(error => {
          console.error('获取权限失败:', error);
          // 权限获取失败时设置空权限数组，而不是reject
          commit("SET_PERMISSIONS", []);
          resolve({ data: [] });
        });
    });
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
